import { toLocaleBrowserSettings } from 'src/i18n/numberLocale';

export const parseCompactNumber = (value: number, unit?: string) => {
  if (!unit) {
    return value.toString();
  }

  const unitMapper = {
    k: 1000,
    M: 1000000,
    B: 1000000000,
    T: 1000000000000,
  };

  const multiplier = unitMapper[unit as keyof typeof unitMapper] || 1;

  const multipliedNumber = toLocaleBrowserSettings(value * multiplier);
  return multipliedNumber;
};
